<template>
  <div id="job-group">
    <comp-header
      :headerPosition="headerPos"
      :leftLink="headerLeftLink"
      :rightLink="headerRightLink"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
      :rightClick="confirm"
    ></comp-header>
    <comp-tag-tab-list
      :tagList="tmpTagList"
      @clickTagList="clickTag"
    ></comp-tag-tab-list>
    <div class="job-list">
      <select-input
        @click.native="addTmpTag(job)"
        v-for="job in jobs"
        :key="job.id"
        :inputType="typeCheck"
        :inputID="job.jobCode"
        :inputValue="job.jobName"
        :labelFor="job.jobCode"
        :labelValue="job.jobName"
        v-model="selectedTags"
      ></select-input>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompTagTabList from '@/components/CompTagTabList';
import SelectInput from '@/components/SelectInput';

export default {
  name: 'job-group-page',

  mixins: [
    common,
  ],

  data() {
    return {
      headerPos: '',
      headerLeftLink: '취소',
      headerRightLink: '완료',
      headerPageTitle: '직종선택',

      typeCheck: 'checkbox',

      checkID: 'testCheck', // label의 'for' 값과 공유
      checkValue: '체크박스', // label의 텍스트와 공유

      tagList: this.$store.getters.getTagList,
      tmpTagList: this.$store.getters.getTmpTagList,

      jobs: this.$store.getters.getJobs,
      selectedTags: [],
    };
  },

  components: {
    'comp-header': CompHeader,
    'comp-tag-tab-list': CompTagTabList,
    'select-input': SelectInput,
  },

  methods: {
    addTmpTag(tag) {
      if (this.selectedTags.indexOf(tag.jobName) < 0) {
        this.$store.dispatch('addTmpTag', tag).then();
      } else {
        const tmpList = this.$store.getters.getTmpTagList;
        for (let ii = 0; ii < tmpList.length; ii += 1) {
          if (tag.jobName === tmpList[ii].jobName) {
            this.$store.dispatch('delTmpTag', ii).then();
            break;
          }
        }
      }
      this.tmpTagList = this.$store.getters.getTmpTagList;
    },
    confirm() {
      this.$store.dispatch('copyTmpTagList').then(() => this.goPrevious());
    },
    clickTag(tag) {
      const tmpList = this.$store.getters.getTmpTagList;
      for (let ii = 0; ii < tmpList.length; ii += 1) {
        if (tag.jobName === tmpList[ii].jobName) {
          this.$store.dispatch('delTmpTag', ii).then();
          break;
        }
      }
      this.tmpTagList = this.$store.getters.getTmpTagList;
      this.selectedTags = this.$store.getters.getTmpTagNameList;
    },
  },

  mounted() {
    this.$store.dispatch('copyTagList').then();
    this.tmpTagList = this.$store.getters.getTmpTagList;
    this.selectedTags = this.$store.getters.getTmpTagNameList;
  },

  destroyed() {
    this.$store.dispatch('clearTmpTagList').then();
  },
};
</script>

<style lang="scss" src="../../scss/acc-job-group.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/acc/acc-job-group.vue